import moment from 'moment'
import { DATE_FORMATS } from '@/libs/composables/date.js'
import { i18n } from '@/libs/i18n'

export const SESSION_TYPES = {
  MANUAL: 'MANUAL',
  LOGIN: 'LOGIN',
}

export class BaseSession {
  constructor(data) {
    this.model = data
  }

  get id() {
    return this.model.id
  }

  get type() {
    return this.model.type
  }

  get app() {
    return this.model.app || i18n.global.t('settings.security.unnamedSession')
  }

  get fingerprint() {
    return this.model.fingerprint
  }

  get device() {
    return this.model.device || i18n.global.t('settings.security.unknownDevice')
  }

  get isTokenSession() {
    return this.type === SESSION_TYPES.MANUAL
  }

  get expiredAt() {
    if (!this.model.expiredAt) return null
    return moment(this.model.expiredAt).format(DATE_FORMATS.short)
  }

  get osIcon() {
    return this.model.osIcon
  }

  get slotList() {
    return []
  }

  get updatedAt() {
    return moment(this.model.updatedAt)
  }
}
